/**
 * =============================================================================
 * Componente: ReferralAccessGate
 * Versão: 1.0.0 (2026-05-04)
 *
 * Descrição:
 *   Gate de acesso ao módulo Indicação no nível da PÁGINA (admin/tenant).
 *   Quando `admin_access_blocked = true` (tier free com saldo de créditos
 *   esgotado), substitui o conteúdo pelo `ReferralPaywall` em vez de mostrar
 *   listagens/dashboards. Não toca em RPCs — bloqueio é exclusivamente UI,
 *   conforme decisão do produto (4.7).
 * =============================================================================
 */
import { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import { useReferralAccess } from '@/hooks/useReferralAccess';
import { ReferralPaywall } from './ReferralPaywall';

interface ReferralAccessGateProps {
  children: ReactNode;
}

export function ReferralAccessGate({ children }: ReferralAccessGateProps) {
  const { data, isLoading } = useReferralAccess();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-16">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (data?.admin_access_blocked) {
    return (
      <ReferralPaywall
        title="Você atingiu o limite gratuito do módulo Indicação"
        subtitle="Suas 20 conversões inclusas foram utilizadas. Escolha um plano para continuar."
      />
    );
  }

  return <>{children}</>;
}
